import { LISTING_STATES } from '../types';
import GenericStateBadge from './GenericStateBadge';

export default function StateBadge({
  state,
  statesMap,
}: {
  state: string;
  statesMap?: Record<string, { label: string; color: string }>;
}) {
  return <GenericStateBadge value={state} statesMap={statesMap ?? LISTING_STATES} />;
}
